import { themes } from 'seal-ui-components';

export default class DefaultTheme {
    constructor() {
        this.baseTheme = themes.baseTheme;
    }

    getBaseTheme() {
        return this.baseTheme;
    }
}
